<div class="side-modal" [class.active]="active">
    <div class="side-modal-background" (click)="close()"></div>

    <div class="side-modal-container styled-scroll"
        [style.paddingBottom.px]="paddingBottom"
        (click)="$event.stopPropagation()">
        <ng-container *ngIf="title !== ''">
            <div class="side-modal-header">
                <h2>
                    {{ title }}
                </h2>

                <button class="side-modal-close" (click)="close()">
                    <svg-icon src="assets/images/icon-times.svg"></svg-icon>
                </button>
            </div>
        </ng-container>

        <ng-container *ngIf="title === ''">
            <div class="close-button-container">
                <button class="side-modal-close" (click)="close()">
                    <svg-icon src="assets/images/icon-times.svg"></svg-icon>
                </button>
            </div>
        </ng-container>

        <div class="side-modal-body" [style.padding.px]="padding">
            <form [formGroup]="formGroup" (ngSubmit)="apply()"
                (keydown.enter)="handleFormEnter($any($event))">
                <ng-content></ng-content>

                <app-spacer [bottom]="32"></app-spacer>

                <div class="row button-sticky">
                    <div class="col-12 col-lg-6 button-sticky-reset"
                        *ngIf="showResetButton">
                        <app-button (onClick)="reset()" class="add-button"
                            [phantom]="true">
                            {{ resetButtonText }}
                        </app-button>
                    </div>

                    <div class="col-12 button-sticky-apply"
                        [ngClass]="showResetButton ? 'col-lg-6' : ''"
                        *ngIf="showApplyButton">
                        <app-button (onClick)="apply()" class="add-button"
                            [disabled]="loading || disableApplyButton">
                            {{ applyButtonText }}
                        </app-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>